import React from "react";
import { Helmet } from "react-helmet";
import { useStaticQuery, graphql } from "gatsby";
import { ISeo } from "../../interfaces/seo";

const SEO = ({
  title,
  description,
  pathname,
  image,
  keywords
}: ISeo) => {

  const { site } = useStaticQuery(graphql` query { site { siteMetadata { title description siteUrl } } } `);
  const metaTitle = title || site.siteMetadata.title;
  const metaDescription = description || site.siteMetadata.description;
  const url = pathname ? `${site.siteMetadata.siteUrl}${pathname}` : site.siteMetadata.siteUrl;
  const metaImage = image ? `${site.siteMetadata.siteUrl}${image}` : null;

  return (
    <Helmet
      htmlAttributes={{
        lang: 'en',
      }}
    >

      <title>{metaTitle}</title>
      <meta name="description" content={metaDescription} />
      <meta name="keywords" content={keywords} />
      <meta property="og:title" content={metaTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:url" content={url} />
      {metaImage && <meta property="og:image" content={metaImage} />}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={metaTitle} />
      <meta name="twitter:description" content={metaDescription} />
      {metaImage && <meta name="twitter:image" content={metaImage} />}
    </Helmet>
  );
};

export default SEO;



